import { render } from "./SplitPanelShell.vue?vue&type=template&id=6e0975bb"
import script from "./SplitPanelShell.vue?vue&type=script&lang=js"
export * from "./SplitPanelShell.vue?vue&type=script&lang=js"

import "../styles/split-panel-shell.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__